import { render } from "./ProfilePanelUserAvatar.vue?vue&type=template&id=00fbcd2e&scoped=true"
import script from "./ProfilePanelUserAvatar.vue?vue&type=script&lang=js"
export * from "./ProfilePanelUserAvatar.vue?vue&type=script&lang=js"

import "./ProfilePanelUserAvatar.vue?vue&type=style&index=0&id=00fbcd2e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fbcd2e"]])

export default __exports__